import { PositionCoverContentEnum } from "./../common/props/orchestrator";
import { ITheme, SkinType } from "~/styles/theme.type";
import { VITRINA } from "./skins/vitrina";
import { ASSETS_URL } from "@commons-monorepo/index";

export const themeV2: ITheme = {
  themeColors: {
    id: "b-violeta",
    name: "B Violeta",
    isPrime: false,
    button: "#703FFF",
    text: "#FFFFFF",
    background: "#F8F4FF",
  },
  cover: {
    id: "default",
    name: "Default",
    coverImage:
      `${ASSETS_URL}/prod/devices/personalization/Sumerian_blanca.png`,
    webCover:
      `${ASSETS_URL}/prod/devices/personalization/Sumerian_blanca.png`,
    isPrime: false,
    prime: false,
  },
  promotionsCover: {
    id: "default",
    name: "Default",
    coverImage:
      `"${ASSETS_URL}/prod/personalizations/cover/promotions.jpg"`,
    webCover:
      `"${ASSETS_URL}/prod/personalizations/cover/promotions.jpg"`,
    isPrime: false,
    prime: false,
  },
  wholesaleCover: {
    id: "default",
    name: "Default",
    coverImage:
      `${ASSETS_URL}/prod/personalizations/cover/wholesale.jpg`,
    webCover:
      `${ASSETS_URL}/prod/personalizations/cover/wholesale.jpg`,
    isPrime: false,
    prime: false,
  },
  template: VITRINA as SkinType,
  templateId: "VITRINA",
  fontFamily: "inter",
  logo: "",
  config: {
    cover: {
      enabled: true,
      text: "",
      position: PositionCoverContentEnum.center,
      enabledButton: true,
      textButton: "",
      sliderArrowEnabled: true,
    },
    footer: {
      darkMode: true,
    },
  },
};
